import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const hotKeywords = ["长安十二时辰", "科幻", "张艺谋", "悬疑短剧", "人世间"];

export default function SearchBanner() {
  const [searchParams] = useSearchParams();
  const [value, setValue] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    setValue(searchParams.get("q") ?? "");
  }, [searchParams]);

  const submit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const keyword = value.trim();
    navigate(keyword ? `/search?q=${encodeURIComponent(keyword)}` : "/search");
  };

  return (
    <section className="w-full bg-background-100 px-4 py-8 md:px-8 md:py-10">
      <div className="mx-auto w-full max-w-6xl">
        <div className="rounded-lg border border-background-200 bg-background-50 px-4 py-5 md:px-6 md:py-6">
          <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
            <div className="lg:w-[38%]">
              <h2 className="font-heading text-lg font-black text-foreground-950 md:text-xl">
                想看什么，直接搜
              </h2>
              <p className="mt-1 text-xs text-foreground-600 md:text-sm">
                支持片名、导演、演员与类型关键词
              </p>
            </div>
            <form
              onSubmit={submit}
              className="flex w-full items-center gap-2 rounded-md border border-background-300 bg-background-50 px-3 py-2 lg:w-[46%]"
            >
              <span className="flex h-5 w-5 items-center justify-center text-foreground-500">
                <i className="ri-search-line text-sm" />
              </span>
              <input
                value={value}
                onChange={(e) => setValue(e.target.value)}
                placeholder="例如：狂飙、悬疑、王家卫"
                className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-500"
              />
              <button
                type="submit"
                className="shrink-0 rounded bg-primary-600 px-3.5 py-1.5 text-xs font-medium text-background-50 transition-colors hover:bg-primary-700 whitespace-nowrap cursor-pointer"
              >
                搜索
              </button>
            </form>
            <div className="flex flex-wrap items-center gap-2 lg:w-[16%]">
              <span className="text-xs text-foreground-600">热门：</span>
              {hotKeywords.slice(0, 2).map((word) => (
                <button
                  key={word}
                  type="button"
                  onClick={() => navigate(`/search?q=${encodeURIComponent(word)}`)}
                  className="rounded-md bg-secondary-100 px-2 py-1 text-xs text-secondary-900 transition-colors hover:bg-secondary-200 cursor-pointer whitespace-nowrap"
                >
                  {word}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}